/**
 * @file useMembership.js
 * @description 会员中心页逻辑
 * @module features/user/composables/useMembership
 */

import { computed, ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useUserStore } from '@/stores/user'

export function useMembership() {
  const userStore = useUserStore()
  const { user } = storeToRefs(userStore)

  const selectedPlan = ref(0)
  const membershipPlans = [
    {
      name: '月度会员',
      price: 48,
      discount: '春季优惠，原价68',
      benefits: ['会员时长：30天', '享受会员专属折扣', '海量资源免费更新'],
      color: '#ff8a65',
    },
    {
      name: '季度会员',
      price: 78,
      discount: '春季优惠，原价108',
      benefits: ['会员时长：90天', '享受会员专属折扣', '海量资源免费更新'],
      color: '#4caf50',
    },
    {
      name: '永久会员',
      price: 148,
      discount: '春季优惠，原价198',
      benefits: ['会员时长：永久', '享受会员专属折扣', '高速下载不限速'],
      color: '#7986cb',
    },
  ]

  const userTypeText = computed(() => {
    switch (user.value?.type) {
      case 0:
        return '普通'
      case 1:
        return '会员'
      case 2:
        return '永久会员'
      default:
        return '未知用户类型'
    }
  })

  function selectPlan(index) {
    selectedPlan.value = index
  }

  return {
    user,
    selectedPlan,
    membershipPlans,
    userTypeText,
    selectPlan,
  }
}
